


































import StateButton from '@/components/inputs/StateButton.vue';
import { auth } from '@/store/firestore';
import { Global } from '@/store/globalz';
import userx from '@/store/modules/userx';
import { Dictionary } from '@/util/dictionary';
import { BModal } from 'bootstrap-vue';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import QuestComponent from './QuestComponent.vue';

@Component({
  components: { StateButton },
})
export default class SfrmQuestModal extends Vue {
  public questComponent: QuestComponent | null = null;
  public get titleHtml() {
    return `Stabfish.io RE:MASTER (mobile) Open Test`;
  }
  public get hasAccount() {
    return userx.user?.email;
  }
  public created() {
    Global.sfrmQuestModal = this;
  }
  public mounted() {
  }
  public show(questComponent: QuestComponent) {
    this.questComponent = questComponent;
    (this.$refs.myModal as BModal).show();
  }

  public showError(error: any) {
    this.$root.$emit('error', error);
  }

  private OnCreateAccount() {
    this.$router.push({ name: 'user' });
  }
  private async OnCheck() {
    if (!this.hasAccount || !auth.currentUser) {
      this.showError('You must create an account first.');
      return;
    }

    const result = await auth.currentUser.getIdTokenResult(true);
    if (result.claims.sfrmid) {

      if (this.questComponent) {
        this.questComponent.progress.progresses[0] = 1;
        userx.userDoc.timeLimitedQuestProgress = { ...userx.userDoc.timeLimitedQuestProgress };
        this.questComponent.onOpenClaim();
      }
      (this.$refs.myModal as BModal).hide();
    } else {
      this.showError('Your account is not linked to Stabfish.io RE:MASTER. Please follow the instructions.');
    }

  }
  private OnDownload() {
    window.open('https://stabfish.io/remaster/mobile', 'sfrmMobile');
  }
  private OnAppStore() {
    window.open('https://apps.apple.com/app/id6746701108', 'sfrmMobile');
  }
  private OnPlayStore() {
    window.open('https://play.google.com/store/apps/details?id=com.ZytechAISdnBhd.Stabfish.ioReMaster', 'sfrmMobile');
  }
}
